import { useTranslation } from "react-i18next";
import { AppContext, AppAction } from "helpers/context";
import { useState, useContext, useEffect } from "react";
import {
    Dialog, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell,
    TableBody, TableSortLabel
} from '@mui/material';
import styles from "./hidden-locations.module.scss"
import { downloadItem } from "../../download/download-item";

interface Direction {
    code: "asc" | "desc";
    name: "asc" | "desc";
    [key: string]: "asc" | "desc"
}


const HiddenLocations: React.FC = () => {
    const [t] = useTranslation();
    const [context, dispatch] = useContext(AppContext);
    const currentHiddenLocationsModal = context.currentHiddenLocationsModal;
    const [tableData, setTableData] = useState<any[]>([]);
    const [active, setActive] = useState<keyof Direction>("code");
    const [direction, setDirection] = useState<Direction>({ code: "asc", name: "asc" });


    const handleSetTableData = (property?: keyof Direction) => {// property: 排序字段
        let sortKey = property || active;
        if (property) {
            if (!tableData.length) {
                return;
            }
            setActive(sortKey);
            direction[sortKey] = direction[sortKey] === "asc" ? "desc" : "asc";
            setDirection({ ...direction });
        }
        let arr = [...currentHiddenLocationsModal.tableData];
        arr.sort((a: any, b: any) => {
            if (!a || !b) {
                return 0;
            }

            const aValue = a?.[sortKey];
            const bValue = b?.[sortKey];

            if (!aValue) {
                return direction[sortKey] === "asc" ? -1 : 1;
            } else if (!bValue) {
                return direction[sortKey] === "asc" ? 1 : -1;
            }

            if (direction[sortKey] === "asc") {
                return String(aValue).localeCompare(String(bValue), 'zh-CN', { numeric: true })
            } else {
                return String(bValue).localeCompare(String(aValue), 'zh-CN', { numeric: true })
            }
        });
        setTableData([...arr]);
    };

    const downloadExcel = () => {
        const name = context.currentMultipleLocations?.name;
        const tableData = context.currentMultipleLocations?.items;
        if (!name || !tableData || tableData.length === 0) {
            return;
        }
        // downloadItem(context, tableData, name, t)
        if (context.currentMultipleLocations) {
            downloadItem(tableData, context.currentMultipleLocations, t);
        }
    }

    useEffect(() => {
        if (currentHiddenLocationsModal?.open && currentHiddenLocationsModal.tableData) {
            handleSetTableData()
        }
    }, [currentHiddenLocationsModal])

    return (
        currentHiddenLocationsModal &&
        context.currentMultipleLocations &&
        <Dialog
            open={currentHiddenLocationsModal.open}
            sx={{
                "& .MuiPaper-root": {
                    maxWidth: "60vw"
                }
            }}
        >
            <div className={styles.dialogContainer}>
                <div className={styles.dialogHeader}>{t("locations.hiddenTable.header", { num: tableData.length, key: t("locations." + context.currentMultipleLocations?.aggregationUnit) })}</div>
                <div className={styles.dialogContent}>
                    <p>{t("locations.hiddenTable.content", { num: tableData.length })}</p>
                    <Paper
                        className={styles.table}
                    >
                        <TableContainer sx={{ height: "100%", flex: 1 }}>
                            <Table
                                stickyHeader
                                aria-label="sticky  table"
                                size="small"
                                style={{
                                    tableLayout: "fixed",
                                    width: "100%",
                                    minWidth: "100%"
                                }}
                            >
                                <TableHead>
                                    <TableRow className={styles.row}>
                                        <TableCell
                                            align="left"
                                        >
                                            <TableSortLabel
                                                active={active === "code"}
                                                onClick={() => handleSetTableData("code")}
                                                direction={(direction as any).code}
                                            >
                                                {t("locations.add.code")}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell
                                            align="left"
                                        >
                                            <TableSortLabel
                                                active={active === "name"}
                                                onClick={() => handleSetTableData("name")}
                                                direction={(direction as any).name}
                                            >
                                                {t("locations.add.name")}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell
                                            align="left"
                                        >
                                            <TableSortLabel
                                                    active={active === context.currentMultipleLocations?.aggregationUnit}
                                                    onClick={() => handleSetTableData(context.currentMultipleLocations?.aggregationUnit)}
                                                    direction={(direction as any)[context.currentMultipleLocations?.aggregationUnit]}
                                            >
                                                    {t("locations." + context.currentMultipleLocations?.aggregationUnit)}
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((item) =>
                                        <TableRow key={item.id}>
                                            <TableCell>
                                                {item.code}
                                            </TableCell>
                                            <TableCell>

                                                {item.name}
                                            </TableCell>
                                            <TableCell>
                                                {t("locations.add.invalidValue")}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </div>
                <div className={styles.dialogFoot}>
                    <Button
                        color="success"
                        variant="text"
                        onClick={() => {
                            dispatch({
                                type: AppAction.setCurrentHiddenLocationsModal,
                                payload: {
                                    ...currentHiddenLocationsModal,
                                    open: false,
                                }
                            })
                        }}
                    >
                        {t(`buttons.close`)}
                    </Button>
                    <Button
                        color="success"
                        variant="contained"
                        onClick={downloadExcel}
                    >
                        {t(`buttons.export`)}
                    </Button>
                </div>
            </div >
        </Dialog>
    );
};

export default HiddenLocations;
